import React, { useState, useRef, useEffect } from "react";
import { Paper, Button } from "@material-ui/core";
import { useFormik } from "formik";
import { useUpdateEffect } from "ahooks";
import useStyles from "../../styles/groupsStyle";
import { useGroupUsersDispatch, useGroupUsersState } from "./Provider";
import LoadingIndicator from "../../components/commons/LoadingIndicator";
import SingleSelector from "../../components/SingleSelector";
import SearchInput from "../../components/SearchInput";
import { useTranslation } from "../../langs/useTranslation";
import TransferGroupModal from "./Category/TransferGroupModal";
import { toast } from "@/helpers/toast"
import modalConfirm from "@/components/Modal/modalConfirm";
import { FormItem } from "@/components/Form";
import localforage from 'localforage';

import UserTableList from './UserTableList';
import UserManagementApi from '@/apis/userManagementApi';
import _ from 'lodash';

const GroupsUsers = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [roleList, setRoleList] = useState([]);
  const userTableRef = useRef(null);
  const selectedIdsRef = useRef([]);
  const isReset = useRef(true);

  const { currentGroup, loadingGroup,currentCompanyId } = useGroupUsersState();
  const { reloadCategoryTree } = useGroupUsersDispatch();

  // table loading
  const [tableLoading, setTableLoading] = useState(true)
  const [pageSetting,setPageSetting] = useState(
    {
      page:1,
      page_size: 20,
      total: 0,
      order_by_column: null,// 排序相关
      order_by_desc: null
    },
  )
  // 列表多选
  const [selectedRowKeys, setSelectedRowKeys] = useState([])

  // 是否全选
  const [checkedAll, setCheckedAll] = useState(false);

  // table data
  const [tableData, setTableData] = useState([])

  // 当前列表的门店
  const [userGroupsData, setUserGroupsData] = useState([])

  const [state,setState] = useState({
    transferGroupModalOpen: false, // 是否开启选择框
    storeExcludeKeysKeys: [], // 当前用户的不可见门店
    selectUserIds: [] // 选择的用户id列表
  })

  const currentGroupId = !currentGroup
    ? []
    : Array.isArray(currentGroup.id)
    ? currentGroup.id
    : [currentGroup.id];

  const initialValues = {
    status: -1,
    otpRequired: -1,
    roleId: "",
    keywords: ""
  };

  const { values, handleChange, handleSubmit, handleReset } = useFormik({
    initialValues,
    onSubmit: () => {
      setCheckedAll(false)
      setSelectedRowKeys([])
      pageSetting.page = 1
      reloadTableData()
    },
    onReset: (values) => {
      pageSetting.page = 1
      pageSetting.page_size = 20
      pageSetting.order_by_column = null
      pageSetting.order_by_desc = null
      setSelectedRowKeys([])
      setCheckedAll(false)
      setTimeout(()=>{
        reloadTableData('rest')
      },0)
    }
  });

  const getRoleList = async () => {
    const user_company_id = await localforage.getItem("userCompanyID")
    const { roles } = await UserManagementApi.GetRoleList({
      company_id: currentCompanyId ? currentCompanyId : user_company_id
    });
    setRoleList(roles);
  };

  const resetQuery = () => {
    reloadCategoryTree();
    handleReset(initialValues);
  };

  // 归属和移出门店
  const operateApi = async (invisibleGroupIds, isRemoveGroup) => {
    const user_company_id = await localforage.getItem("userCompanyID")
    await UserManagementApi.UpdateUserInvisibleStore({
      company_id: currentCompanyId ? currentCompanyId : user_company_id,
      groupIds: [],
      invisibleGroupIds,
      isRemoveGroup,
      keywords: values.keywords,
      otpRequired: values.otpRequired,
      roleId: values.roleId,
      status: values.status ?? -1,
      uncheckedUserIds: [],
      userIds: state.selectUserIds.length > 0 ? state.selectUserIds : selectedRowKeys
    });
    reloadCategoryTree();
    reloadTableData()
  };

  const handleTranserGroupConfirm = async (checkedKeys, uncheckedKeys) => {
    await operateApi(uncheckedKeys, false);
    setState({
      transferGroupModalOpen: false,
      groupExcludeKeysKeys: [],
      selectUserIds: []
    })
  };

  useUpdateEffect(() => {
    getRoleList();
  }, [currentCompanyId]);

  useUpdateEffect(() => {
    reloadTableData();
  }, [currentGroup && currentGroup.id, currentCompanyId]);

  useEffect(() => {
    getRoleList();
    reloadTableData();
  }, []);

  const reloadTableData = async (type) => {
    const user_company_id = await localforage.getItem("userCompanyID")
    const params = {
      company_id: currentCompanyId ? currentCompanyId : user_company_id,
      page: pageSetting.page,
      page_size: pageSetting.page_size,
      order_by_column: pageSetting.order_by_column,
      order_by_desc: pageSetting.order_by_desc === "ascend" ? "asc" : "desc",
      status: values.status ?? -1,
      otpRequired: -1,
      roleId: values.roleId,
      keywords: values.keywords,
      groupIds: currentGroupId
    }
    // 重置搜索条件
    if(type==='rest'){
      params.page = 1
      params.status = -1
      params.roleId = ''
      params.keywords = ''
    }
    const res = await UserManagementApi.GetList(params,{
      showLoading: true
    })
    const data = res.users
    setPageSetting({
      ...pageSetting,
      total:res.total
    })
    setTableData(data)
    setTableLoading(false)
    setUserGroupsData(res.groups)
  }


  const tableFunc = {
    // 归属门店
    handleTransferGroup : () => {
      if(selectedRowKeys.length<=0){
        toast.info(t({ defaultMessage: "未选择账号" }));
        return
      }

      setState({
        transferGroupModalOpen: true,
        groupExcludeKeysKeys: [],
        selectUserIds: selectedRowKeys
      })
    },
    // 将账号移出门店
    handleRemoveGroup : () => {
      if (selectedRowKeys.length <= 0) {
        toast.info(t({defaultMessage: "未选择账号"}));
        return
      }
      modalConfirm({
        title: t({ defaultMessage: "提示信息" }),
        content: t({ defaultMessage: "确定要移出吗？" }),
        onConfirm: async () => {
          await operateApi(currentGroupId, true);
          toast.success(t({ defaultMessage: "操作成功" }));
        }
      });
    },

    // 归属门店,点击行门店字段
    handleChangeStore : row => {
      setState({
        transferGroupModalOpen: true,
        groupExcludeKeysKeys: row.invisibleGroups.map(item => item.id),
        selectUserIds: [row.id]
      })
    },
    // 排序，分页等等
    onChange: (pagination, filters, sorter, extra) => {
      console.log('params', pagination, filters, sorter, extra);
      pageSetting.order_by_column = null
      pageSetting.order_by_desc = null
      if(sorter.column){
        pageSetting.order_by_column = sorter.field
        // pageSetting.order_by_desc = sorter.order === 'descend' ? 'desc' : 'asc'
        pageSetting.order_by_desc = sorter.order
      }
      pageSetting.page = pagination.current
      pageSetting.page_size = pagination.pageSize
      reloadTableData()
    },
    // 多选
    onSelectChange : (newSelectedRowKeys) => {
      setSelectedRowKeys(newSelectedRowKeys);
    },
    // 全选
    handleChangeCheckedAll: async (e) => {
      setCheckedAll(e.target.checked);
      if(!e.target.checked){
        setSelectedRowKeys([])
        return
      }
      // 需要获取到全部的table列表数据
      const user_company_id = await localforage.getItem("userCompanyID")
      const res = await UserManagementApi.GetList({
        company_id: currentCompanyId ? currentCompanyId : user_company_id,
        page: 1,
        page_size: 9999999,
        order_by_column: "",
        order_by_desc:  "desc",
        status: '',
        search_value: '',
        group_ids: []
      },{
        showLoading: true
      })
      const data = res.data.list
      _.each(data,item=>{
        if(!_.includes(selectedRowKeys,item.id)) {
          selectedRowKeys.push(item.id)
        }
      })
      setSelectedRowKeys(_.cloneDeepWith(selectedRowKeys,true))
    }
  }

  // 关闭门店选择
  const handleCloseTransferGroupModal = () => {
    setState({
      transferGroupModalOpen: false,
      groupExcludeKeysKeys: [],
      selectUserIds: []
    })
  }



  return (
    <div className={classes.main}>
      <Paper elevation={0} className={classes.deviceInGroup}>
        <form onSubmit={handleSubmit}>
          <FormItem>
            <div className={classes.tableTop}>
              <div>
                {currentGroup && (
                  <>
                    <span className={classes.groupName}>
                      {currentGroup.title}
                    </span>
                    <span className={classes.groupCount}>
                      {pageSetting.total}
                      {t({ defaultMessage: "人" })}
                    </span>
                  </>
                )}
              </div>
              <SearchInput
                placeholder={t({ defaultMessage: "搜索" })}
                name="keywords"
                icon={null}
                value={values.keywords}
                onChange={handleChange}
              />
            </div>
            <div className={classes.tableQueryForm}>
              <SingleSelector
                placeholder={t({ defaultMessage: "选择状态" })}
                options={[
                  { name: t({ defaultMessage: "激活" }), id: 1 },
                  { name: t({ defaultMessage: "未激活" }), id: 0 }
                ]}
                clearable
                name="status"
                value={values.status}
                onChange={handleChange}
              />
              <SingleSelector
                placeholder={t({ defaultMessage: "选择角色" })}
                options={roleList}
                clearable
                name="roleId"
                value={values.roleId}
                onChange={handleChange}
              />
              <Button
                variant="contained"
                color="primary"
                type="submit"
                style={{ marginRight: 8,padding:'6px 16px' }}
              >
                {t({ defaultMessage: "查询" })}
              </Button>
              <Button variant="outlined" onClick={resetQuery}>
                {t({ defaultMessage: "重置" })}
              </Button>
            </div>
          </FormItem>
        </form>
        {/*{loadingGroup && <LoadingIndicator />}*/}
        <div
          className={`${classes.tableWrap} user-table-list paltform-antd-table`}
          style={{ visibility: loadingGroup ? "hidden" : "" }}
        >
          <UserTableList
            tableLoading={tableLoading}
            pageSetting={pageSetting}
            selectedRowKeys={JSON.parse(JSON.stringify(selectedRowKeys))}
            checkedAll={checkedAll}
            tableData={tableData}
            userGroupsData={userGroupsData}
            tableFunc={tableFunc}
          />
        </div>
        <TransferGroupModal
          open={state.transferGroupModalOpen}
          excludeKeys={state.groupExcludeKeysKeys}
          onClose={handleCloseTransferGroupModal}
          onConfirm={handleTranserGroupConfirm}
        />
      </Paper>
    </div>
  );
};

export default GroupsUsers;
